// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.campaign {
    stroke: #009188;
  }
  
  .campaign:hover {
    stroke: #004846;
  }`, "",{"version":3,"sources":["webpack://./src/css/campaignListcss.css"],"names":[],"mappings":"AAAA;IACI,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB","sourcesContent":[".campaign {\n    stroke: #009188;\n  }\n  \n  .campaign:hover {\n    stroke: #004846;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
